function compileDescription(key, value, textToReplace) {
    if (!value) return textToReplace
    // console.log(key, textToReplace)
    // console.log(textToReplace.replace(`%{${key}}`, value))
    return textToReplace.replaceAll(`%{${key}}`, value)

}

function normalizeValue($form, d, textToReplace) {
    let v;
    if (d.name.includes('journal_entry[counterpart_attributes][name]') || d.name.endsWith("counterpart_id]")) {
        const newValue = $('input[name="journal_entry[counterpart_attributes][name]"').val()
        if (newValue === '') {
            v = $(`[name="${d.name}"]`).find(':selected').text().split("-")[0]
        } else {
            return ['journal_entry[counterpart_id]', d.value, textToReplace]
        }
    } else  if (d.name.endsWith("_id]")) {
        v = $(`[name="${d.name}"]`).find(':selected').text()
    } else if (d.name.includes("date") || d.name.includes("data_documento") || d.name.includes("payment_date")) {
        v = d.value && d.value.split("-").reverse().join("/")
    } else {
        // console.log("textToReplace11", d.value)
        v = d.value
    }
    return [d.name, v, textToReplace]
}

function initCompileDescription() {
    const $form = $('form.journal_entry')

    const $fields = $form.find(":not(textarea#journal_entry_description):input")
    $.each($fields, function (i, $el) {
        $($el).on("change.compile-desc keyup.compile-desc paste.compile-desc", function () {
            const data = $form.serializeArray();
            const $description = $('form.journal_entry #journal_entry_description')
            const $field = $('form.journal_entry #journal_entry_document_type_id')
            let textToReplace = $field.data('text-to-replace')
            if (textToReplace) {
                $.each(data, function (i, d) {
                    textToReplace = compileDescription(...normalizeValue($form, d, textToReplace))
                })
                $description.val(textToReplace);
            } else {
                $description.val('');
            }
        })
    })
}

function initChangeDescription() {
    const $element = $('#journal_entry_document_type_id')
    $element.on('change', function (e) {
        if (this.value) {
            $.getJSON(`/admin/document_types/${this.value}/description`, function (data) {
                $element.data('text-to-replace', data.description_template)
                $element.trigger('change.compile-desc')
            });
        }
    })
}

function initDescription() {
    initCompileDescription()
    initChangeDescription()
}

export { initDescription }